export const asyncEvery = async <T>(
  array: Array<T>,
  predicate: (element: T) => Promise<boolean>
) => {
  for (const element of array) {
    if (!(await predicate(element))) return false;
  }
  return true;
};
